var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkOffBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 21.7402L21.5402 20.2802L7.21023 5.95023L3.25023 1.99023L1.99023 3.25023L4.69023 5.95023H4.05023C2.94023 5.95023 2.06023 6.84023 2.06023 7.95023L2.05023 18.9502C2.05023 20.0602 2.94023 20.9502 4.05023 20.9502H19.6902L21.7402 23.0002L23.0002 21.7402ZM22.0002 7.95023C22.0502 6.84023 21.1602 5.95023 20.0502 6.00023H16.0502V3.95023C16.0502 2.84023 15.1602 1.95023 14.0502 2.00023H10.0502C8.94023 1.95023 8.05023 2.84023 8.05023 3.95023V4.27023L22.0002 18.2702V7.95023ZM14.0502 6.00023H10.0002V3.95023H14.0502V6.00023Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOffBlack);
export default __webpack_public_path__ + "static/media/work-off-black.b8a335bf7a6713e5303accb641f2d5ae.svg";
export { ForwardRef as ReactComponent };